/**
 * ControlsLeft
 *
 * 职责：左侧控制按钮组（重复、倍速）
 * 词级对齐开关已移动到显示设置面板中，这里不再显示单独按钮
 */

import React from 'react';
import { RepeatButton } from './RepeatButton';
import SpeedSelector from '../SpeedSelector';

interface ControlsLeftProps {
  isRepeatMode: boolean;
  canRepeatCurrentCue: boolean;
  playbackRate: number;
  isSpeedSelectorOpen: boolean;
  disabled: boolean;
  onRepeatClick: () => void;
  onPlaybackRateChange: (rate: number) => void;
  onSpeedSelectorOpenChange: (open: boolean) => void;
}

export const ControlsLeft: React.FC<ControlsLeftProps> = ({
  isRepeatMode,
  canRepeatCurrentCue,
  playbackRate,
  isSpeedSelectorOpen,
  disabled,
  onRepeatClick,
  onPlaybackRateChange,
  onSpeedSelectorOpenChange,
}) => {
  return (
    <div className="control-buttons-left">
      <RepeatButton
        isActive={isRepeatMode}
        disabled={disabled || !canRepeatCurrentCue}
        onClick={onRepeatClick}
      />
      <div className={`speed-control ${isSpeedSelectorOpen ? 'active' : ''}`}>
        <SpeedSelector
          value={playbackRate}
          onValueChange={onPlaybackRateChange}
          disabled={disabled}
          onOpenChange={onSpeedSelectorOpenChange}
        />
      </div>
    </div>
  );
};

